import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast, Toaster } from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { MdShoppingCart, MdPerson, MdPhone, MdLocationOn, MdPayment, MdStore } from 'react-icons/md';
import axios from 'axios';
import { server } from '../../../server';
import statusColors from "../../../utils/statusColor";

const Loader = () => (
  <div className="flex justify-center items-center h-full">
    <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-cyan-500"></div>
  </div>
);

export default function AllOrdersForDelivery() {
  const dispatch = useDispatch();
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const { deliveryUser } = useSelector((state) => state.deliveryUser);

  const loadAssignedOrders = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${server}/delivery/assigned-orders`, { withCredentials: true });
      setOrders(response.data.orders || []);
      setError("");
    } catch (requestError) {
      setError(requestError.response?.data?.message || "Could not load delivery assignments");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { loadAssignedOrders(); }, []);

  useEffect(() => {
    if (error) {
      toast.error(`Failed to fetch orders: ${error}`);
    }
  }, [error]);

  const handleStatusChange = async (orderId, newStatus) => {
    setUpdatingStatus(true);
    try {
      await axios.put(`${server}/order/update-order-status-delivery/${orderId}`, { status: newStatus }, { withCredentials: true });
      loadAssignedOrders();
      toast.success('Order status updated successfully');
    } catch (error) {
      toast.error('Failed to update order status');
    } finally {
      setUpdatingStatus(false);
    }
  };

  return (
    <div className="w-full min-h-screen p-8 bg-gray-100">
      <h3 className="text-3xl font-bold text-gray-800 mb-6">All Orders for Delivery</h3>
      {isLoading || updatingStatus ? (
        <Loader />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {orders?.map((order) => (
            <div key={order._id} className="bg-white rounded-lg shadow-md overflow-hidden transition-transform duration-300 hover:scale-105">
              <div className="p-6">
                <Link to={`/order/${order._id}`} className="block p-6 hover:bg-cyan-50 hover:border rounded-[5px] mb-2">
                  <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center">
                        <MdShoppingCart size={24} className="text-cyan-500 mr-3" />
                        <h3 className="text-xl font-semibold text-gray-800 underline">
                          Order #{order._id.slice(-6)}
                        </h3>
                      </div>
                  </div>
                </Link>
                <div className="flex items-center mb-3">
                  <MdPerson size={20} className="text-gray-500 mr-3" />
                  <p className="text-gray-600">{order.user.name}</p>
                </div>
                <div className="flex items-center mb-3">
                  <MdPhone size={20} className="text-gray-500 mr-3" />
                  <p className="text-gray-600">{order.user?.phoneNumber}</p>
                </div>
                <div className="flex items-center mb-3">
                  <MdLocationOn size={20} className="text-gray-500 mr-3" />
                  <p className="text-gray-600">{`${order.shippingAddress.address1}, ${order.shippingAddress.city}, ${order.shippingAddress.province} ${order.shippingAddress.zipCode}`}</p>
                </div>
                <div className="flex items-center mb-3">
                  <MdPayment size={20} className="text-gray-500 mr-3" />
                  <p className="text-gray-600">{order.paymentInfo.type}</p>
                </div>
                <div className="flex items-center mb-3">
                  <MdStore size={20} className="text-gray-500 mr-3" />
                  <p className="text-gray-600">{order.shop.name}</p>
                </div>
                <div className="mt-4 pt-4 border-t border-gray-200">
                  <p className="text-sm font-medium text-gray-500 mb-2">
                    Total Price: ${order.totalPrice.toFixed(2)}
                  </p>
                  <span className={`px-2 py-1 rounded-full text-xs ${statusColors[order.status]}`}>
                      {order.status}
                  </span>
                  {/* <div className="flex items-center ">
                    <label htmlFor={`status-${order._id}`} className="text-sm font-medium text-gray-500 mr-2">
                      Update Order Status:
                    </label>
                    <select
                      id={`status-${order._id}`}
                      className="form-select text-sm w-[200px] mt-2 border h-[35px] rounded-[5px] bg-cyan-100 border-gray-300 focus:ring-cyan-500 focus:border-cyan-500"
                      value={order.status}
                      onChange={(e) => handleStatusChange(order._id, e.target.value)}
                    >
                      <option value="Pending">Pending</option>
                      <option value="Accepted">Accepted</option>
                      <option value="In Transit">In Transit</option>
                      <option value="Delivered">Delivered</option>
                      <option value="Cancelled">Cancelled</option>
                    </select>
                  </div> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <Toaster position="bottom-center" />
    </div>
  );
}
